import React from 'react';
import './Header.css';
import useAuthStore from '../stores/authStore';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <header className="app-header">
      <div className="app-header__content">
        <div className="app-header__logo">
          <div className="app-header__logo-icon">
            <DocumentTextIcon width={32} height={32} style={{ color: 'white' }} />
          </div>
          <div className="app-header__logo-text">
            <span className="app-header__logo-main">Legal Simplifier</span>
            <span className="app-header__logo-sub">by БУРАВЧИК</span>
          </div>
        </div>
        <div className="app-header__nav">
          <a 
            href={isAuthenticated ? "/documents" : "/auth"} 
            className="app-header__button"
          >
            {isAuthenticated ? "Мои документы" : "Войти"}
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header; 
